const main = {
    margin: '0',
    display: 'grid',
    padding: '0',
};
const linkWrapper = { display: 'flex', alignItems: 'center' };
const capitalize = { textTransform: 'capitalize' };
const ctaButtonsWrapper = {
    mb: 0,
    display: 'flex',
    flexDirection: { desktop: 'row', mobile: 'column' },
    gap: '1rem',
    mt: { mobile: '2rem' },
    position: 'relative',
    justifyContent: 'flex-end',
    width: {
        desktop: '371px!important',
        mobile: '100%!important',
    },
    alignItems: 'flex-end',
};
const ctaButtonsTOUWrapper = {
    mb: 0,
    display: 'flex',
    flexDirection: { desktop: 'row', mobile: 'column' },
    gap: '1rem',
    mt: '2rem',
    backgroundColor: { desktop: 'white' },
    position: 'relative',
    justifyContent: 'flex-end',
    width: {
        desktop: '371px!important',
        mobile: '100%!important',
    },
    alignItems: 'flex-end',
};
const cardHeader = {
    width: '100%',
    display: 'flex',
    padding: {
        desktop: '40px 80px',
        mobile: '1rem 1.5rem',
    },
};
const subtitle = {
    display: 'flex',
    flexDirection: {
        desktop: 'row',
        mobile: 'column',
    },
    justifyContent: 'space-between',
    width: '100%',
    '& .MuiButton-root': {
        width: {
            desktop: '192px',
            mobile: '100%',
        },
    },
    '& .MuiTypography-root': {
        alignSelf: 'flex-end',
        margin: {
            mobile: '1rem 0 0 0',
        },
    },
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const subTitleWrapper = { mt: { desktop: 4, mobile: 2 }, mb: 2 };
const titleWrapper = {
    width: '90%!important',
    h1: {
        width: '100%',
    },
    h6: {
        width: '100%',
    },
};
const pageContentWrapper = (isLargeDesktop) => {
    return {
        width: isLargeDesktop ? '50%' : '100%',
        minWidth: {
            desktop: '50%',
            mobile: '100%',
        },
        backgroundColor: {
            desktop: 'white',
        },
        display: 'flex',
        gap: 0,
        flexDirection: 'column',
        padding: {
            mobile: '24px',
            desktop: '40px',
        },
        ' .MuiTypography-root': {
            marginLeft: {
                mobile: '0',
            },
        },
        '> .MuiBox-root': {
            width: { desktop: isLargeDesktop ? '55%' : '80%' },
        },
    };
};
const decorationContainer = (asStandAlonePage) => {
    return {
        display: 'flex',
        flexDirection: 'column',
        width: asStandAlonePage ? '100%' : '45%',
        justifyContent: 'start',
        alignItems: 'center',
        minHeight: '40vh',
        mt: {
            desktop: asStandAlonePage ? '18vh' : '22vh',
            mobile: 0,
        },
        padding: {
            mobile: '0 24px',
            desktop: 0,
        },
    };
};
export default {
    decorationContainer,
    main,
    ctaButtonsWrapper,
    linkWrapper,
    cardHeader,
    pageContentWrapper,
    subtitle,
    ctaButtonsTOUWrapper,
    titleWrapper,
    subTitleWrapper,
    capitalize,
};
